import React, { useState } from 'react';
import { COMMUNITIES, PROFESSIONS, DISTRICTS, AGE_GROUPS, GENDER_OPTIONS, EDUCATION_LIST } from '../constants/masterData';

const FilterSection = ({ title, icon, items, selected, onToggle, searchable }) => {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const filtered = searchable ? items.filter(i => i.toLowerCase().includes(search.toLowerCase())) : items;
  const count = selected.length;

  return (
    <div style={{ marginBottom: 12, borderRadius: 12, border: '1.5px solid rgba(255,107,0,0.15)', overflow: 'hidden', background: 'rgba(255,255,255,0.7)' }}>
      <div onClick={() => setOpen(!open)} style={{
        padding: '10px 14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        cursor: 'pointer', background: open ? 'rgba(255,107,0,0.06)' : 'transparent',
        transition: 'background 0.2s',
      }}>
        <div style={{ fontWeight: 700, fontSize: '0.82rem', color: '#BF360C', display: 'flex', alignItems: 'center', gap: 6 }}>
          <span>{icon}</span> {title}
          {count > 0 && <span style={{ background: '#FF6B00', color: 'white', borderRadius: 99, padding: '1px 8px', fontSize: '0.68rem' }}>{count}</span>}
        </div>
        <span style={{ fontSize: '0.8rem', color: '#9E6040', transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'none' }}>▼</span>
      </div>

      {open && (
        <div style={{ padding: '8px 12px 12px', borderTop: '1px solid rgba(255,107,0,0.1)' }}>
          {searchable && (
            <input
              style={{ width: '100%', padding: '6px 10px', border: '1.5px solid rgba(255,107,0,0.2)', borderRadius: 8, fontSize: '0.78rem', fontFamily: "'Outfit',sans-serif", marginBottom: 8, outline: 'none' }}
              placeholder={`Search ${title.toLowerCase()}...`}
              value={search} onChange={e => setSearch(e.target.value)}
            />
          )}
          <div style={{ maxHeight: 180, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
            {filtered.map(item => {
              const val = typeof item === 'object' ? item.value || item.label : item;
              const label = typeof item === 'object' ? item.label : item;
              const isSelected = selected.includes(val);
              return (
                <label key={val} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 6px', borderRadius: 8, cursor: 'pointer', background: isSelected ? 'rgba(255,107,0,0.08)' : 'transparent', transition: 'background 0.15s' }}>
                  <input type="checkbox" checked={isSelected} onChange={() => onToggle(val)} style={{ accentColor: '#FF6B00', width: 14, height: 14 }} />
                  <span style={{ fontSize: '0.8rem', fontWeight: isSelected ? 700 : 400, color: isSelected ? '#E55100' : '#333' }}>{label}</span>
                </label>
              );
            })}
          </div>
          {count > 0 && (
            <button onClick={() => selected.forEach(v => onToggle(v))} style={{ marginTop: 8, fontSize: '0.72rem', color: '#E55100', background: 'none', border: 'none', cursor: 'pointer', fontWeight: 600, textDecoration: 'underline' }}>
              Clear all ({count})
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default function FilterPanel({ filters, onChange, onApply, onClear }) {
  const toggle = (key, val) => {
    const curr = filters[key] || [];
    const next = curr.includes(val) ? curr.filter(v => v !== val) : [...curr, val];
    onChange({ ...filters, [key]: next });
  };

  const totalActive = Object.values(filters).flat().length;

  return (
    <div style={{ background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(16px)', borderRadius: 20, padding: '16px', border: '1px solid rgba(255,255,255,0.7)', boxShadow: '0 4px 24px rgba(255,107,0,0.1)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
        <div style={{ fontFamily: "'Baloo 2',sans-serif", fontWeight: 700, fontSize: '1rem', color: '#BF360C' }}>
          🎛️ Filters {totalActive > 0 && <span style={{ background: '#FF6B00', color: 'white', borderRadius: 99, padding: '2px 8px', fontSize: '0.72rem' }}>{totalActive} active</span>}
        </div>
        {totalActive > 0 && (
          <button onClick={onClear} style={{ fontSize: '0.75rem', color: '#E55100', background: 'none', border: '1.5px solid rgba(255,107,0,0.3)', padding: '4px 12px', borderRadius: 99, cursor: 'pointer', fontWeight: 600 }}>
            Clear All
          </button>
        )}
      </div>

      <FilterSection title="District Wise"    icon="🗺️" items={DISTRICTS}                     selected={filters.districts||[]}   onToggle={v=>toggle('districts',v)} />
      <FilterSection title="Community Wise"   icon="👥" items={COMMUNITIES}                   selected={filters.communities||[]} onToggle={v=>toggle('communities',v)} searchable />
      <FilterSection title="Gender Wise"      icon="⚧️" items={GENDER_OPTIONS}                selected={filters.genders||[]}     onToggle={v=>toggle('genders',v)} />
      <FilterSection title="Age Wise"         icon="🎂" items={AGE_GROUPS.map(a=>({label:a.label,value:`${a.min}-${a.max}`}))} selected={filters.age_groups||[]} onToggle={v=>toggle('age_groups',v)} />
      <FilterSection title="Profession Wise"  icon="💼" items={PROFESSIONS}                   selected={filters.professions||[]} onToggle={v=>toggle('professions',v)} searchable />

      {/* Booth Number filter — text input */}
      <div style={{ marginBottom:12, borderRadius:12, border:'1.5px solid rgba(255,107,0,0.15)', overflow:'hidden', background:'rgba(255,255,255,0.7)', padding:'10px 14px' }}>
        <div style={{ fontWeight:700, fontSize:'0.82rem', color:'#BF360C', marginBottom:8, display:'flex', alignItems:'center', gap:6 }}>
          🏫 Booth Number
          {filters.booth_number && <span style={{ background:'#FF6B00', color:'white', borderRadius:99, padding:'1px 8px', fontSize:'0.68rem' }}>1</span>}
        </div>
        <input
          type="number"
          style={{ width:'100%', padding:'7px 10px', border:'1.5px solid rgba(255,107,0,0.2)', borderRadius:8, fontSize:'0.82rem', fontFamily:"'Outfit',sans-serif", outline:'none' }}
          placeholder="Enter booth number..."
          value={filters.booth_number||''}
          onChange={e => onChange({...filters, booth_number: e.target.value})}
        />
        {filters.booth_number && (
          <button onClick={()=>onChange({...filters, booth_number:''})} style={{ marginTop:6, fontSize:'0.72rem', color:'#E55100', background:'none', border:'none', cursor:'pointer', fontWeight:600, textDecoration:'underline' }}>
            Clear
          </button>
        )}
      </div>

      <button onClick={onApply} style={{
        width: '100%', padding: '12px', marginTop: 8, border: 'none',
        borderRadius: 12, background: 'linear-gradient(135deg,#E55100,#FF6B00)',
        color: 'white', fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer',
        fontFamily: "'Outfit',sans-serif", boxShadow: '0 4px 16px rgba(255,107,0,0.4)',
        transition: 'all 0.2s',
      }}
      onMouseEnter={e=>{e.target.style.transform='translateY(-1px)';e.target.style.boxShadow='0 8px 24px rgba(255,107,0,0.55)';}}
      onMouseLeave={e=>{e.target.style.transform='none';e.target.style.boxShadow='0 4px 16px rgba(255,107,0,0.4)';}}>
        ✅ Apply Filters
      </button>
    </div>
  );
}